class PetstockHandtap extends HTMLElement {
  constructor() {
    super();

    this.button = this;
    this.wrap = this.button.closest('.petstock-product');

    if (!this.wrap) return;

    this.button.addEventListener("click", this.onHandleClick.bind(this));
  }

  onHandleClick(e) {
    e.preventDefault();
    
    this.wrap.classList.toggle('show-image-hover');
  }
}

customElements.define("petstock-handtap", PetstockHandtap);

class WeightSelect extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector("select");
    this.wrap = this.closest(".product-wrap");

    if (!this.select && !this.wrap) return;

    this.select.addEventListener("change", this.onSelectChange.bind(this));
  }

  onSelectChange(e) {
    this.value = this.select.value;
    this.url = e.target.options[e.target.selectedIndex].getAttribute("data-url");

    this.changeProductInfo(this.value, this.url)
  }

  changeProductInfo(value, url) {
    if (this.wrap.querySelectorAll('form[data-product="' + value + '"]').length > 0) {
      this.wrap.querySelectorAll("form").forEach((form) => form.classList.add("hidden"));
      this.wrap.querySelector('form[data-product="' + value + '"]').classList.remove("hidden");
    }

    if (this.wrap.querySelectorAll('.our-range-product-review[data-product="' + value + '"]').length > 0) {
      this.wrap.querySelectorAll(".our-range-product-review").forEach((review) => review.classList.add("hidden"));
      this.wrap.querySelector('.our-range-product-review[data-product="' + value + '"]').classList.remove("hidden");
    }

    this.wrap.querySelectorAll("a:not(.our-range-product-review-href)").forEach((a) => a.setAttribute("href", url));
  }
}

customElements.define("weight-select", WeightSelect);

window.addEventListener("pageshow", () => {
  if (document.querySelectorAll('weight-select').length > 0) {
    let checkWeight = window.location.search.includes('?weight=4kg');
    document.querySelectorAll("weight-select select").forEach((select) => {
      let index = select.getAttribute("data-index");
      if (checkWeight && select.querySelectorAll('option[data-weight="4kg"]').length > 0) {
        let option = select.querySelector('option[data-weight="4kg"]');
        index = option.getAttribute("data-index");
        
        select.selectedIndex = index;
        const weightSelect = select.closest('weight-select');
        weightSelect.changeProductInfo(select.value, option.getAttribute("data-url"));

        select.style.opacity = "1";
      } else {
        select.selectedIndex = index;
        select.style.opacity = "1";
      }
    });
  }
});